import { difficultyOf } from '@shared/minigames';
import type { CardData } from '@shared/types';
import { gameInfo } from './info';
import { TurnGame, type TurnGameConfig } from './TurnGame';

function MatBolnaCard({ card }: { card: CardData }) {
  return (
    <div className={`mg-card matbolna ${difficultyOf(card)}`}>
      <span className="mg-label">Get them to say</span>
      <span className="mg-big">{card.text}</span>
      {card.gloss && <span className="mg-gloss">{card.gloss}</span>}
      <span className="mg-label forbidden">Mat bolna</span>
      <ul className="mg-taboo">
        {(card.taboo ?? []).map((w) => (
          <li key={w}>{w}</li>
        ))}
      </ul>
    </div>
  );
}

const config: TurnGameConfig = {
  game: 'mat-bolna',
  info: gameInfo('mat-bolna'),
  defaults: { teams: ['', ''], difficulties: ['easy', 'medium'], categories: [], turnSeconds: 60, turnsPerTeam: 3 },
  timerOptions: [45, 60, 90],
  filters: ['difficulty'],
  fouls: true,
  renderCard: (card) => <MatBolnaCard card={card} />,
  readyHint: (team) =>
    `Pick a describer from ${team}. Someone from another team stands behind them to watch for forbidden words and hit the buzzer.`,
};

export function MatBolna() {
  return <TurnGame config={config} />;
}
